import { render, staticRenderFns } from "./GrownFishModal.vue?vue&type=template&id=72b0260f&scoped=true&"
import script from "./GrownFishModal.vue?vue&type=script&lang=js&"
export * from "./GrownFishModal.vue?vue&type=script&lang=js&"
import style0 from "./GrownFishModal.vue?vue&type=style&index=0&id=72b0260f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b0260f",
  null
  
)

export default component.exports